export default __webpack_public_path__ + "static/media/triangle_1.bacb735e.svg";